import { render, staticRenderFns } from "./tenderDocument.vue?vue&type=template&id=2ff8e7b5&"
import script from "./tenderDocument.vue?vue&type=script&lang=js&"
export * from "./tenderDocument.vue?vue&type=script&lang=js&"
import style0 from "./tenderDocument.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports